type PercentageDiscountPreviewProps = {
  percentageDiscount: number
}

const PercentageDiscountPreview: React.FC<PercentageDiscountPreviewProps> = ({ percentageDiscount }) => {
  if (percentageDiscount <= 0) {
    return null
  }

  return (
    <div className="absolute right-2 top-2 z-pill rounded-full bg-nelo-red px-2 py-1 font-inter text-xs font-bold text-white">
      -{percentageDiscount}%
    </div>
  )
}

export default PercentageDiscountPreview
